import React from 'react'

export const StudentSituations = () => {
  return (
    <div>StudentSituations</div>
  )
}
